import {
  SET_PUBLISHING,
  SET_POST_SIDEBAR_OPEN,
  SET_SAVING_DRAFT,
  SET_POST_DATA
} from './mutation-types'

export default {
  [SET_PUBLISHING]: (state, { publishing }) => {
    state.publishing = publishing
  },
  [SET_SAVING_DRAFT]: (state, { savingDraft }) => {
    state.savingDraft = savingDraft
  },
  [SET_POST_SIDEBAR_OPEN]: (state, { isSidebarOpen }) => {
    state.isSidebarOpen = isSidebarOpen
  },
  [SET_POST_DATA]: (state, { postData }) => {
    state.postData = postData
  }
}
